import { EtlState, IEtlMetadata, IExtractEtlMetadata, ILoadMetadata, ITransformEtlMetadata } from '@ViewModels';
import { css } from 'aphrodite';
import React from 'react';
import { styleSheet } from './styles';

interface IETLStatusProps {
	state: EtlState;
}

export const ETLStageStatus: React.FC<IETLStatusProps> = ({ state }) => {
	const getStatusStyles = () => {
		if (state === EtlState.InProgress) return [styleSheet.status, styleSheet.inProgress];
		if (state === EtlState.Idle) return [styleSheet.status, styleSheet.idle];
		if (state === EtlState.IdleWithError) return [styleSheet.status, styleSheet.idleWithError];
		if (state === EtlState.Suspended) return [styleSheet.status, styleSheet.suspended];
		if (state === EtlState.SuspendedWithError) return [styleSheet.status, styleSheet.suspendedWithError];
		return [styleSheet.status, styleSheet.notStarted];
	};

	return <div className={css(...getStatusStyles())} />;
};

interface IETLConnectorProps {
	metadata: IExtractEtlMetadata | ITransformEtlMetadata | ILoadMetadata;
}

export const ETLConnector: React.FC<IETLConnectorProps> = ({ metadata }) => {
	const isDashed = metadata.state === EtlState.InProgress;

	const errorStates = [EtlState.SuspendedWithError, EtlState.IdleWithError];
	const isDashedRed = errorStates.includes(metadata.state) || errorStates.includes(metadata.lastState);

	return (
		<div className={css(styleSheet.connectorContainer)}>
			<div
				className={css(
					styleSheet.connector,
					isDashed ? styleSheet.dashedLine : styleSheet.solidLine,
					isDashedRed ? styleSheet.dashedRedLine : null
				)}
				role='connector'
			/>
		</div>
	);
};

interface IETLVisualsProps {
	etl: IEtlMetadata;
}

export const ETLVisuals: React.FC<IETLVisualsProps> = ({ etl }) => {
	const stages = ['extract', 'transform', 'load'] as const;

	return (
		<div className={css(styleSheet.container)}>
			<div className={css(styleSheet.stagesContainer)}>
				{stages.map((stage, index) => {
					const metadata = etl[stage];

					return (
						<React.Fragment key={stage}>
							{index !== 0 && <ETLConnector metadata={metadata} />}
							<div className={css(styleSheet.stageContainer)}>
								<ETLStageStatus
									state={
										stage === 'extract' && etl.preProcess && etl.preProcess.state === EtlState.InProgress
											? etl.preProcess.state
											: metadata.state
									}
								/>
							</div>
						</React.Fragment>
					);
				})}
			</div>
		</div>
	);
};

export const ETLSubConnector = ({ status }: { status: EtlState }) => {
	return (
		<div className={css(styleSheet.substepRow)}>
			<div className={css(styleSheet.substepConnectorContainer)}>
				<div className={css(styleSheet.substepConnector)} />
				<div
					className={css(
						styleSheet.substepStatusIndicator,
						status === EtlState.InProgress && styleSheet.substepStatusActive
					)}
				/>
			</div>
		</div>
	);
};
